import { FC, ReactNode, useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { Button } from './button'
import { cn } from '../../lib/utils'

type CollapsibleSectionProps = {
  title: string
  children: ReactNode
  defaultOpen?: boolean
  className?: string
}

/**
 * CollapsibleSection
 *
 * A collapsible container for filters, search, and other toolbar content.
 * Useful for mobile-friendly interfaces where space is limited.
 */
const CollapsibleSection: FC<CollapsibleSectionProps> = ({
  title,
  children,
  defaultOpen = true,
  className
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className={cn("border-b border-neutral200 dark:border-neutral700", className)}>
      <Button
        variant="ghost"
        className="w-full justify-between px-6 py-4 h-auto hover:bg-neutral50 dark:hover:bg-neutral800"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="font-semibold text-neutral900 dark:text-neutral100 px-2">{title}</span>
        {isOpen ? (
          <ChevronUp className="w-5 h-5 text-neutral500" />
        ) : (
          <ChevronDown className="w-5 h-5 text-neutral500" />
        )}
      </Button>

      <div
        className={cn(
          "overflow-hidden transition-all duration-200 ease-in-out",
          isOpen ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"
        )}
      >
        <div className="px-6 pb-4">
          {children}
        </div>
      </div>
    </div>
  )
}

export default CollapsibleSection
